import styles from "@/components/login-tip-popup.module.css";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { t } from "i18next";
import { JSX, useEffect, useRef } from "react";

interface LoginTipPopupProps {
	closePopup: () => void;
	isClosing: boolean;
	isShown: boolean;
}

function LoginTipPopup({
	closePopup,
	isClosing,
	isShown,
}: LoginTipPopupProps): JSX.Element {
	const timeoutId = useRef<number | null>(null);

	useEffect(() => {
		if (timeoutId.current) {
			window.clearTimeout(timeoutId.current);
		}
		if (isClosing) {
			timeoutId.current = window.setTimeout(() => {
				closePopup();
			}, 350);
		}
	}, [closePopup, isClosing]);

	if (!isShown) {
		return <></>;
	}
	return (
		<div
			className={clsx(
				styles["login-tip-popup"],
				!isClosing && "fade-in-scale",
				isClosing && "fade-out-scale",
			)}
		>
			<FontAwesomeIcon icon={faUserCircle} />
			<h1>{t("notLoggedIn")}</h1>
			<div className={styles["description"]}>
				{t("notLoggedInDescription")}
			</div>
		</div>
	);
}

export default LoginTipPopup;
